module.exports = __webpack_public_path__ + "static/media/FotosCentro7.1b3d8e68.jpg";